import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import FieldsArray from '../FieldsArray';
import ArtistFieldset from './ArtistFieldset';
import { formValues } from 'redux-form';
import InfoLink from '../../InfoLink';
import belongsTo from 'lib/utils/belongsTo';
import OpenHouseFieldset from './OpenHouseFieldset';

const ArtistsFieldset = formValues('category_id')((props) => {
  const availableTexts = {
    local: {
      title: 'Artists',
      groupName: 'artists',
      btnTitle: 'Artist',
      fieldPlaceholder: 'an Artist or Performer'
    },
    enterprise: {
      title: 'Speakers',
      groupName: 'speakers',
      action: 'speaking',
      btnTitle: 'Speaker',
      fieldPlaceholder: 'a Speaker'
    }
  };

  let texts = availableTexts.local;
  if (props.category_id !== undefined) {
    const category = props.categories.find(e => e.id === props.category_id);
    if (category && category.market_name === 'Enterprise') {
      texts = availableTexts.enterprise;
    }
  }

  return (
    <div className="row">
      <div className="col condensed-form-group">
        <label>{texts.title}</label>
        <InfoLink link="https://support.evvnt.com/hc/en-us/articles/216672268-Details-Adding-an-artist-performer-or-speaker"/>
        <p>
          Some of our network use this information to showcase
          the {texts.groupName} appearing and promote your listings
          on their {texts.groupName.slice(0, -1)} profiles
        </p>
        <FieldsArray
          name="artists"
          formErrors={props.formErrors}
          component={ArtistFieldset}
          componentProps={{ placeholder: texts.fieldPlaceholder }}
          resourceName={texts.btnTitle}
        />
      </div>
    </div>
  );
});

const AdditionalInfoFieldset = formValues({
  category_id: 'category_id',
  sub_categories: 'sub_categories',
})(({ formErrors, categories, currencies, category_id, sub_categories, config }) => {
  const openHouseCategory = parseInt(config.get('open_house_category_id'));
  const selectedCategories = (sub_categories || []).map(c => c.id).concat(category_id);

  const showOpenHouse = openHouseCategory ?
    selectedCategories.some(cat => belongsTo(categories, openHouseCategory, cat)) : false;
  const showArtists = openHouseCategory ?
    !selectedCategories.every(cat => belongsTo(categories, openHouseCategory, cat)) : true;

  return (
    <div className="AdditionalInfoFieldset">
      {showOpenHouse && <OpenHouseFieldset formErrors={formErrors} currencies={currencies} />}
      {showArtists && <ArtistsFieldset formErrors={formErrors} categories={categories} />}
      <div className="row">
        <div className="col-12">
          <FormField
            label="Hashtag"
            error={formErrors.get('hashtag')}
            name="hashtag"
            component="input"
            type="text"
            className="form-control"
            prefix="#"
            prefixPattern={/#/}
            placeholder="Enter your event's primary hashtag used to promote your event"
            infoUrl="https://support.evvnt.com/hc/en-us/articles/360020724314-Details-How-to-create-a-hashtag"
          />
        </div>
      </div>
    </div>
  );
});

AdditionalInfoFieldset.propTypes = {
  formErrors: PropTypes.object,
  categories: PropTypes.array.isRequired,
};

export default AdditionalInfoFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/AdditionalInfoFieldset.jsx